<!-- 头部 -->
<template>
  <div class="header">
    <div class="header-top">
      <img :src="'./static/img/home/header.svg'" alt />
      <div class="header-right">
        <div>
          <span>注册 | 登录</span>
          <!-- <img :src="'./static/img/home/search.png'" alt /> -->
        </div>
        <!-- <h2>仅供医疗专业人士参考</h2> -->
      </div>
    </div>
    <div :class="{'header-box':true,'is-fixed':isFixed}">
      <el-menu
        :default-active="activeIndex2"
        style="border-top: 1px solid rgb(211, 211,211);"
        class="header-inner"
        mode="horizontal"
        @select="handleSelect"
        active-text-color="#ffd04b"
      >
        <el-menu-item index="home">
          <div class>主页</div>
        </el-menu-item>
        <el-submenu index="2">
          <template slot="title">
            <div class>肿瘤治疗</div>
          </template>
          <el-submenu index="2-1">
            <template slot="title">冷冻消融</template>
            <el-menu-item>肾癌</el-menu-item>
          </el-submenu>
          <el-submenu index="2-2">
            <template slot="title">经动脉化疗栓塞</template>
            <el-menu-item index="2-2-1">肝细胞癌（ HCC ）</el-menu-item>
            <el-menu-item index="2-2-2">结直肠癌肝转移（ mCRC ）</el-menu-item>
          </el-submenu>
          <el-submenu index="2-3">
            <template slot="title">选择性体内放射疗法</template>
            <el-menu-item>肝细胞癌（ HCC ）</el-menu-item>
            <el-menu-item>结直肠癌肝转移（ mCRC ）</el-menu-item>
          </el-submenu>
          <el-menu-item index="2-4">经皮穿刺引流</el-menu-item>
        </el-submenu>
        <el-menu-item index="3">
          <div class>临床案例</div>
        </el-menu-item>
        <el-menu-item index="4">
          <div class>内容中心</div>
        </el-menu-item>
        <el-menu-item index="5">
          <div class>患者教育</div>
        </el-menu-item>
        <el-menu-item index="6">
          <div class>会议活动</div>
        </el-menu-item>
        <el-menu-item index="7">
          <div class>与医者同心</div>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- <div :class="{'header-box':true,'is-fixed':isFixed}">
      <ul class="header-inner">
        <li
          :class="{active:activeIndex==item.key}"
          v-for="(item,index) in dataSource"
          :key="index"
          @click="handleSelect(item)"
          class="header-item"
        >{{item.name}}</li>
      </ul>
    </div>-->
    <div style="height:50px" v-if="isFixed"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { throttle } from '@/utils/util'
const FIXHEIGHT = 75
export default {
  name: 'g-header',
  data() {
    return {
      activeIndex: 'therapy',
      isFixed: false
    }
  },
  computed: {
    ...mapGetters(['pageData']),
    dataSource() {
      return this.pageData['mainMenu']
    }
  },
  methods: {
    handleSelect(item) {
      this.activeIndex = item.key
      if (['therapy', 'centre'].includes(item.key)) {
        this.$router.push({
          name: item.key
        })
      }
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.isFixed = scrollTop > FIXHEIGHT
    }
  },
  mounted() {
    this.activeIndex = this.$route.meta.main
    window.addEventListener('scroll', this.handleScroll, true)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style lang='less' scoped>
@head-top: 74.8px;
@head-menu: 50px;
.header {
  font-family: 'SourceHanSansCN-Regular';
  background-color: #fff;
  .header-top {
    height: @head-top;
    max-width: 1400px;
    padding: 0 20px;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > img {
      .wh(345px, 36px);
    }
    .header-right {
      > div {
        display: flex;
        align-items: center;
        > span {
          padding: 7.9px 27.7px 7.9px 23.6px;
          background-color: @theme-blue;
          color: #fff;
          font-size: 17px;
        }
        > img {
          .wh(17px, 19px);
          margin-left: 18.2px;
        }
      }
      > h2 {
        font-size: 14px;
        color: #768088;
        // width: 160px;
        text-align: center;
        margin-top: 4px;
        font-family: 'SourceHanSansCN-Regular';
      }
    }
  }
  .header-box {
    width: 100%;
    border-top: 1px solid rgb(211, 211, 211);
    z-index: 1000;
    background-color: #fff;
    font-family: 'SourceHanSansCN-Regular';
    .header-inner {
      max-width: 1360px;
      margin: 0 auto;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      .header-item {
        font-size: 20px;
        .wh(140px, @head-menu);
        text-align: center;
        line-height: 50px;
        color: #666666;
      }
      .header-item:hover {
        background-color: rgb(240, 240, 240);
        color: #333;
      }
      // .header-item:active {
      //   background-color: @theme-blue;
      //   color: #fff;
      // }
      .active {
        background-color: @theme-blue !important;
        color: #fff !important;
      }
    }
  }
  .is-fixed {
    position: fixed;
    border-bottom: 1px solid rgb(211, 211, 211);
    left: 0px;
    top: 0;
    // top: -@head-menu;
    // transform: translateY(@head-menu);
    // transition: all 1.5s;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gHeaderCopy.vue